/**
 * Rebuy Widget Multi-language Translation
 * Traduce dinamicamente i testi del widget Rebuy in base alla lingua del negozio
 */

(function() {
  'use strict';

  // ========================================
  // CONFIGURAZIONE TRADUZIONI
  // ========================================
  const translations = {
    'thisItem': {
      'it': 'Questo articolo:',
      'en': 'This item:',
      'fr': 'Cet article:',
      'de': 'Dieser Artikel:',
      'es': 'Este artículo:',
      'pt': 'Este item:',
      'nl': 'Dit artikel:',
      'pl': 'Ten produkt:',
      'ja': 'この商品:',
      'zh': '此商品：'
    }
    // Aggiungi altre stringhe da tradurre qui se necessario
    // 'altraStringa': { 'it': 'traduzione', 'en': 'translation' }
  };

  // ========================================
  // RILEVA LINGUA CORRENTE
  // ========================================
  function getCurrentLocale() {
    // Metodo 1: Attributo lang del tag HTML
    const htmlLang = document.documentElement.lang;
    if (htmlLang) {
      return htmlLang.split('-')[0].toLowerCase();
    }
    
    // Metodo 2: Oggetto Shopify.locale (disponibile in Markets)
    if (window.Shopify && window.Shopify.locale) {
      return window.Shopify.locale.toLowerCase();
    }
    
    // Metodo 3: Parsing del pathname per theme multilingua legacy
    const pathParts = window.location.pathname.split('/');
    if (pathParts[1] && pathParts[1].length === 2) {
      return pathParts[1].toLowerCase();
    }
    
    // Fallback
    console.warn('Rebuy Translations: Impossibile rilevare la lingua, uso EN come default');
    return 'en';
  }

  // ========================================
  // FUNZIONE DI TRADUZIONE
  // ========================================
  function translateRebuyLabels() {
    const locale = getCurrentLocale();
    
    // Debug info (rimuovi in produzione se non serve)
    console.log('Rebuy Translations: Lingua rilevata -', locale);
    
    // Traduci "This item:"
    const thisItemTranslation = translations.thisItem[locale] || translations.thisItem['en'];
    const labels = document.querySelectorAll('strong.rebuy-product-label');
    
    let translatedCount = 0;
    labels.forEach(label => {
      const originalText = label.textContent.trim();
      
      // Verifica se è "This item:" in qualsiasi lingua (per evitare traduzioni multiple)
      const isThisItemLabel = Object.values(translations.thisItem).some(
        trans => trans === originalText
      );
      
      if (originalText === 'This item:' || isThisItemLabel) {
        label.textContent = thisItemTranslation;
        translatedCount++;
      }
    });
    
    if (translatedCount > 0) {
      console.log(`Rebuy Translations: ${translatedCount} label tradotte`);
    }
  }

  // ========================================
  // MUTATION OBSERVER
  // ========================================
  // Monitora il DOM per intercettare quando Rebuy carica i suoi widget
  const observer = new MutationObserver((mutations) => {
    let shouldTranslate = false;
    
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        // Verifica solo nodi di tipo Element
        if (node.nodeType === 1) {
          // Controlla se il nodo è un elemento Rebuy o lo contiene
          if (node.classList && (
              node.classList.contains('rebuy-widget') ||
              node.classList.contains('rebuy-product-block') ||
              node.classList.contains('rebuy-cart')
          )) {
            shouldTranslate = true;
          }
          
          // Controlla anche nei figli
          if (node.querySelector && node.querySelector('.rebuy-product-label')) {
            shouldTranslate = true;
          }
        }
      });
    });
    
    if (shouldTranslate) {
      // Piccolo delay per assicurarsi che Rebuy abbia finito il rendering
      setTimeout(translateRebuyLabels, 100);
    }
  });

  // ========================================
  // INIZIALIZZAZIONE
  // ========================================
  function init() {
    // Avvia l'observer sul body
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Traduci elementi già presenti al caricamento
    translateRebuyLabels();
    
    // Listener per eventi Rebuy (se disponibili)
    document.addEventListener('rebuy:cart.change', translateRebuyLabels);
    document.addEventListener('rebuy:product.added', translateRebuyLabels);
    
    console.log('Rebuy Translations: Inizializzato');
  }

  // Avvia quando il DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();